import API from "../utility/axios";
const newApiUrl = "/api/v2";
export const GET_SUBSCRIPTION_BY_USER_CODES = (
  userCode: string
): Promise<any> => {
  return API.get(`${newApiUrl}/subscriptions?user_code=${userCode}`);
};
